(function () {
  if (!document.body.classList.contains('home-cinema')) return;

  var sections = document.querySelectorAll('#MainContent > .shopify-section:not(:has([data-home-cinema]))');
  sections.forEach(function (section, index) {
    section.classList.add('home-reveal');
    if (index % 2 === 1) section.classList.add('home-reveal--left');
    else section.classList.add('home-reveal--right');
  });

  if (!('IntersectionObserver' in window)) {
    sections.forEach(function (section) { section.classList.add('is-visible'); });
    return;
  }

  var observer = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (entry.isIntersecting) {
        entry.target.classList.add('is-visible');
        observer.unobserve(entry.target);
      }
    });
  }, { root: null, rootMargin: '0px 0px -10% 0px', threshold: 0.12 });

  sections.forEach(function (section) { observer.observe(section); });
})();
